export default __webpack_public_path__ + "static/media/logo-morgan-space.7276c312.png";